import { LuSearch } from "@/Components/Icons/Icons.jsx"
export default {
    row1: [
        {
            column: "column1",


            rows: {
                row1: [
                    {
                        name: "dutyExempted",
                        label: "Submission Type",
                        component: "dropdown",
                        width: "30%",
                        options: [
                            { label: "None", value: "None" },
                            { label: "CVD And Addi Duty Importer", value: "CVD And Addi Duty Importer" },
                            { label: "CVD Only", value: "CVD Only" },

                        ],

                        endIconName: "LuChevronDown",
                        iconColor: "gray-400",
                    },
                    {
                        name: "actualCIFValue",
                        label: "Actual CIF Value",
                        component: "text-field",
                        placeholder: "0.00",
                        width: "30%",


                    },
                    {
                        name: "actualDebitDuty",
                        label: "Actual Debit Duty",
                        component: "text-field",
                        placeholder: "0.00",
                        width: "30%",


                    },

                ],
            }
        }
    ]
}

